<template>
<div>
  <div v-if="team.company">
       <moz-input @blur="saveInfo"  v-model="companyName" class="w-54 lg:w-64 xl:w-64" placeholder="Название компании" type="text"></moz-input>
       <MozgoArea @blur="saveInfo" :outerValue="companyComment" v-model="companyComment" class="md:w-4/5  md:mr-20 mt-4" placeholder="Краткая информация"></MozgoArea>
       <div v-if="existingCompanyLogos" class="mt-8 overflow-auto w-full scroll-container">
         <p class="text-additional-text text-10px mb-1 font-semibold">Логотип</p>
         <div class="md:w-auto flex items-center mt-4" :style="{'width': logosWidth+'px'}">
           <div v-for="image in existingCompanyLogos" :key="image" class="image-cont w-24 h-24 mr-4 border flex justify-center items-center relative"
            >
             <img :src="getExistingLogoPrev(image)" class="image">
             <img @click="deleteExistingLogo(image)"  class="cross-img" src="@/assets/SVG/cross-partners.svg" alt="">

           </div>
           <div v-for="image in uploadedCompanyLogos" :key="image.id" class="THIS image-cont w-24 h-24 mr-4 border flex justify-center items-center relative"
            >
             <img :src="getUrlObject(image)" class="image">
             <img  @click="deleteUploadedLogo(image)" class="cross-img" src="@/assets/SVG/cross-partners.svg" alt="">
             <img v-if="spinner" class="absolute spinner" src="@/assets/spinners/tail-spin.svg">
           </div>
           <vue-upload-component ref="upload" class="upl " v-model="uploadedCompanyLogos" :multiple="true" :drop="true"
             :drop-directory="true" :thread="5" :maximum="5 - existingCompanyLogos.length" @input-filter="inputFilter">
             <slot v-if="(uploadedCompanyLogos.length+existingCompanyLogos.length)<5">
             <div class="image-cont cursor-pointer add-picture w-24 h-24 mr-4 border flex justify-center items-center relative">
               <div @click="addLogoClick"
                     class=" outline-none rounded-full flex flex-row justify-center items-center h-8 w-8  cursor-pointer">
                     <img src="@/assets/emty-avatar.png" alt="">
                     <img class="plus-add-icon" src="../../../assets/icons/add.svg" alt="">
               </div>
              </div>
             </slot>
           </vue-upload-component>
         </div>
       </div>
       <span v-show="fileFormatError" class="text-red text-10px md:text-xs font-normal"
             v-text="'Неверный формат файлов'"></span>
     </div>
  </div>
</template>
<script>
import VueUploadComponent from 'vue-upload-component';
import psd from '@/assets/SVG/psd.svg';
import ai from '@/assets/SVG/ai.svg';
import MozgoArea from '@/helpers/mozgoArea.vue';

export default {
  name: 'team-company',
  props: ['team', 'show', 'spinner'],
  components: { VueUploadComponent, MozgoArea },
  data() {
    return {
      companyName: '',
      companyComment: '',
      fileFormatError: false,
      existingCompanyLogos: [],
      uploadedCompanyLogos: [],
      showAddLogoTooltip: false,
    };
  },
  created() {
    if (this.team.company) { // Заполняем данные о компании из me, если комапния есть
      this.companyName = this.team.company.name;
      this.companyComment = this.team.company.description;
      if (this.team.company.media.length < 1) return;
      for (const index in this.team.company.media) {
        this.existingCompanyLogos.push(this.team.company.media[index]);
      }
      this.uploadedCompanyLogos = [];
    }
  },
  methods: {
    uploadCompanyLogo(e) {
      const { files } = e.target;
      this.uploadedCompanyLogos = [...this.uploadedCompanyLogos, ...files].slice(0, 5);
    },

    deleteExistingLogo(logo) {
      const idx = this.existingCompanyLogos.findIndex(lg => lg === logo);
      this.existingCompanyLogos.splice(idx, 1);
    },

    deleteUploadedLogo(file) {
      this.$refs.upload.remove(file);
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        // Will not be added to files
        if (!/\.(jpg|png|psd|ai|svg)$/i.test(newFile.name)) {
          this.fileFormatError = true;
          return prevent();
        }

        if (this.uploadedCompanyLogos.length > 5) {
          return prevent();
        }
      }
    },
    getUrlObject(logoUploadObject) {
      const nameArr = logoUploadObject.name.split('.');
      const fileExt = nameArr[nameArr.length - 1];
      if (fileExt === 'ai') return ai;
      else if (fileExt === 'psd') return psd;
      return URL.createObjectURL(logoUploadObject.file);
    },

    addLogoClick() {
      const label = document.querySelector('.upl input');
      label.click();
      this.fileFormatError = false;
    },
    getExistingLogoPrev(urlImage) {
      if (/\.(psd)$/i.test(urlImage)) {
        return psd;
      }
      if (/\.(ai)$/i.test(urlImage)) {
        return ai;
      }
      return urlImage;
    },
    saveInfo() {
      this.$emit('saveInfo', this.companyName, this.companyComment, this.concatLogos);
    },
  },
  watch: {
    concatLogosLen() {
      this.saveInfo();
    },
    companyLogos() {
      this.existingCompanyLogos = this.companyLogos;
      this.uploadedCompanyLogos = [];
    },
  },
  computed: {
    logosWidth() {
      /*  устанавливаем длину контейнера с логотипами */
      return (this.concatLogos.length + 1) * 110 > 550 ? 550 : (this.concatLogos.length + 1) * 110;
    },
    companyLogos() {
      const logos = [];
      for (const media in this.team.company.media) {
        logos.push(this.team.company.media[media]);
      }
      return logos;
    },
    concatLogos() {
      const uploaded = this.uploadedCompanyLogos.map(logoObj => logoObj.file);
      return [...this.existingCompanyLogos, ...uploaded].slice(0, 5);
    },
    concatLogosLen() {
      return this.concatLogos.length;
    },
  },

};
</script>
<style scoped>
::-webkit-scrollbar {
        margin-right: 20%;
        height: 10px; /* height of horizontal scrollbar ← You're missing this */
        width: 10px; /* width of vertical scrollbar */
        border: 20px solid #d5d5d5;
        border-radius: 10px;
        position: sticky;
        bottom: 0;

    }
.add-picture {
  background-color: #DADADA;
}
    ::-webkit-scrollbar-thumb {
        background-color: #bd006c;
        border: 0px solid transparent;
        border-radius: 9px;
        height: 15px;
        background-clip: content-box;

    }
    .plus-add-icon {
      position: absolute;
      top: -10px;
      right: -10px;
    }
    .file-uploads {
      overflow: visible;
    }
    .upl>>>label {
    cursor: pointer;
  }
  .cross-img {
    background-color: white;
    width: 24px;
    height: 24px;
    padding: 5px;
    position: absolute;
    border-radius: 50%;
    top: -10px;
    right: -10px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08), 0px 0px 2px rgba(0, 0, 0, 0.08);
    cursor: pointer;
  }
</style>
